import React from 'react';
import { func, string } from 'prop-types';
import styles from './styles/styles.module.scss';
import ChevRight from '../../../../../components/svg/shared/ChevRight';

const POUND_SIGN = '#';

const RiverMore = ({ href, onClick }) => {
  const handleOnClick = e => {
    if (href === POUND_SIGN) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <a href={href} onClick={handleOnClick}>
      <div className={styles.chevContainer}>
        <ChevRight />
      </div>
    </a>
  );
};

RiverMore.propTypes = {
  href: string,
  onClick: func
};

RiverMore.defaultProps = {
  href: POUND_SIGN,
  onClick: () => {}
};

export default RiverMore;
